import { P1Service, rawP1Service } from "../../services/P1Service";
import { EwusCredentialsDto, EwusVerificationResultDto } from "../../types/ewus";
import { P1Response } from "../../types/p1Service";
import { CREDENTIALS, EWUS_INITIALIZE, EWUS_VERIFICATION } from "./ewusEndpoints";


class EwusApi {

    getInitialize(appointmentId: number, patientPesel: string) {
        return rawP1Service.post<P1Response<EwusVerificationResultDto>>(
            EWUS_INITIALIZE,
            { appointmentId, patientPesel }
        );
    }

    getEwusVerification(appointmentId: number, patientPesel: string) {
        return rawP1Service.post<P1Response<EwusVerificationResultDto>>(
            EWUS_VERIFICATION,
            {appointmentId, patientPesel},
        );
    }

    setEwusMedicCredentials(data: EwusCredentialsDto) {
        return rawP1Service.put<P1Response<void>>(
            CREDENTIALS,
            data
        );
    }

    getEwusMedicCredentials() {
        return rawP1Service.get<P1Response<void>>(
            CREDENTIALS
        );
    }

    deleteEwusMedicCredentials() {
        return rawP1Service.delete<P1Response<void>>(
            CREDENTIALS
        );
    }

}

export const ewusApi = new EwusApi();